import { deepCopy } from "@/service/topologyHelper";
import { UNIT_LABELS } from "@/service/constants";
import _ from "lodash";
import CommonUIControl from "@/helper/CommonUIControl";
import moment from "moment";

export default {
  install(Vue) {
    Vue.prototype.$helper = {
      deepCopy,
      hex2rgba,
      byteToMebibyte,
      coreToMilicore,
      roundNumber,
      byteToGibibyte,
      viewMemoryData,
      viewCpuData,
      milicoreToCore,
      mebibyteToGibibyte,
      getUsageStyle,
      viewMemoryData2,
      viewCpuData2,
      viewDiskData,
      confirmDelete,
      truncatedText,
      showDate,
      minutesToReadable,
      roundX,
      thousandsFormat,
    };
  },
};

if (window) {
  /** 기존 사용하던 `require`의 폴리필 */
  window.require = (path) => {
    const replacePath = alias
      .filter(([reg]) => reg.test(path))
      .reduce((acc, [reg, replace]) => acc.replace(reg, replace), path);

    return replacePath;
  };
}

const alias = [
  [/^@\//, new URL("../../src", import.meta.url).href + "/"],
  [
    /^~\//,
    new URL("../../src/pages/main/modernframework", import.meta.url).href + "/",
  ],
];

const STEP = 1024;

const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

const byteToMebibyte = (bytes, toFixed = 1) => {
  return roundNumber(bytes / (STEP * STEP), toFixed);
};

const coreToMilicore = (cores, toFixed = 0) => {
  return roundNumber(cores * 1000, toFixed);
};

const milicoreToCore = (milicore, toFixed = 1) => {
  return roundNumber(milicore / 1000, toFixed);
};

const byteToGibibyte = (bytes, toFixed = 1) => {
  return roundNumber(bytes / (STEP * STEP * STEP), toFixed);
};

const mebibyteToGibibyte = (mebibytes, toFixed = 1) => {
  // 1 Mebibyte (MiB) = 1 / 1024 Gibibyte (GiB)
  return roundNumber(mebibytes / STEP, toFixed);
};

const roundX = (value, decimals) => {
  // Convert the value to a number
  const number = parseFloat(value);

  // Check if the value is a valid number
  if (isNaN(number)) {
    return 0;
  }

  // Round the number to the specified number of decimal places
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
};

const roundNumber = roundX;

const viewCpuData = (inputData, noUnit = false) => {
  if (!_.isNull(inputData)) {
    if (inputData >= 0 && inputData < 1000) {
      return `${roundNumber(inputData, 0)}  ${
        !noUnit ? UNIT_LABELS.MiliCores : ""
      }`;
    } else {
      const usageDataInCore = roundNumber(inputData / 1000, 0);
      return `${usageDataInCore} ${!noUnit ? "c" : ""}`;
    }
  } else {
    return `0 ${!noUnit ? "mi" : ""}`;
  }
};
const viewMemoryData = (usageData) => {
  if (!_.isNull(usageData)) {
    if (usageData >= 0 && usageData < 1024) {
      return `${roundNumber(usageData, 0)} ${UNIT_LABELS.MebiByte}`;
    } else {
      const usageDataInGiB = roundNumber(usageData / 1024, 0);
      return `${usageDataInGiB} ${UNIT_LABELS.GibiByte}`;
    }
  } else {
    return `0 ${UNIT_LABELS.MebiByte}`;
  }
};

const viewCpuData2 = (usageData, limitData, objectResult = false) => {
  if (
    _.isNull(usageData) ||
    _.isUndefined(usageData) ||
    _.isNull(limitData) ||
    _.isUndefined(limitData)
  ) {
    return "N/A";
  }

  // Determine the appropriate unit for limitData
  let limitDataFormatted;
  let limitUnit;

  if (limitData >= 1000) {
    limitDataFormatted = roundNumber(limitData / 1000, 1);
    limitUnit = UNIT_LABELS.Core;
  } else {
    limitDataFormatted = limitData;
    limitUnit = UNIT_LABELS.MiliCores;
  }
  if (!_.isNull(usageData) && !_.isUndefined(usageData)) {
    // Determine the appropriate unit for usageData
    let usageDataFormatted;
    let usageUnit;

    if (usageData >= 1000) {
      usageDataFormatted = roundNumber(usageData / 1000, 1);
      usageUnit = UNIT_LABELS.Core;
    } else {
      usageDataFormatted = roundNumber(usageData, 1);
      usageUnit = UNIT_LABELS.MiliCores;
    }

    if (usageUnit == limitUnit || usageDataFormatted == 0) {
      usageUnit = "";
    }

    if (objectResult) {
      return {
        usageData: usageDataFormatted,
        usageUnit: usageUnit,
        limitData: limitDataFormatted,
        limitUnit: limitUnit,
        percent: calPercent(usageData, limitData),
      };
    }

    // Format the output
    return `${usageDataFormatted} ${usageUnit} / ${limitDataFormatted} ${limitUnit}`;
  } else {
    return `${limitDataFormatted} ${limitUnit}`;
  }
};

const viewMemoryData2 = (usageData, limitData, objectResult = false) => {
  if (
    _.isNull(usageData) ||
    _.isUndefined(usageData) ||
    _.isNull(limitData) ||
    _.isUndefined(limitData)
  ) {
    return "N/A";
  }
  // Conversion factors
  const KIBI = 1024;
  const MEBI = KIBI * 1024;
  const GIBI = MEBI * 1024;

  usageData = usageData * MEBI;

  let limitDataFormatted;
  let limitUnit;

  if (limitData >= 1024) {
    limitDataFormatted = roundNumber(limitData / 1024, 1);
    limitUnit = UNIT_LABELS.GibiByte;
  } else {
    limitDataFormatted = limitData;
    limitUnit = UNIT_LABELS.MebiByte;
  }

  // Determine the appropriate unit for usageData
  let usageDataFormatted;
  let usageUnit;

  if (usageData >= GIBI) {
    usageDataFormatted = usageData / GIBI;
    usageUnit = "";
  } else if (usageData >= MEBI) {
    usageDataFormatted = usageData / MEBI;
    usageUnit = UNIT_LABELS.MebiByte;
  } else if (usageData >= KIBI) {
    usageDataFormatted = usageData / KIBI;
    usageUnit = UNIT_LABELS.KibiByte;
  } else {
    usageDataFormatted = usageData;
    usageUnit = UNIT_LABELS.Byte;
  }
  if (usageUnit == limitUnit || usageDataFormatted == 0) {
    usageUnit = "";
  }

  if (objectResult) {
    return {
      usageData: roundNumber(usageDataFormatted, 1),
      usageUnit: usageUnit,
      limitData: roundNumber(limitDataFormatted, 1),
      limitUnit: limitUnit,
      percent: calPercent(usageData / MEBI, limitData),
    };
  }

  // Format the output
  return `${roundNumber(
    usageDataFormatted,
    1,
  )} ${usageUnit} / ${limitDataFormatted} ${limitUnit}`;
};

const viewDiskData = (usageData, limitData, objectResult = false) => {
  const byteToMebiByte = (bytes) => bytes / (1024 * 1024);
  const byteToGibiByte = (bytes) => bytes / (1024 * 1024 * 1024);

  // Check if usageData is null
  let usageDataFormatted;
  let usageUnit;

  if (_.isNull(usageData) || _.isUndefined(usageData)) {
    usageDataFormatted = "N/A";
    usageUnit = "";
  } else if (usageData >= 1024 * 1024 * 1024) {
    usageDataFormatted = roundNumber(byteToGibiByte(usageData), 0);
    usageUnit = UNIT_LABELS.GibiByte;
  } else {
    usageDataFormatted = roundNumber(byteToMebiByte(usageData), 0);
    usageUnit = UNIT_LABELS.MebiByte;
  }

  // Convert limitData from GibiBytes to MebiBytes
  const limitDataInMebiBytes = limitData * 1024;
  let limitDataFormatted;
  let limitUnit;

  if (limitDataInMebiBytes >= 1024) {
    limitDataFormatted = roundNumber(limitDataInMebiBytes / 1024, 0);
    limitUnit = UNIT_LABELS.GibiByte;
  } else {
    limitDataFormatted = roundNumber(limitDataInMebiBytes, 0);
    limitUnit = UNIT_LABELS.MebiByte;
  }

  if (usageUnit == limitUnit) {
    usageUnit = "";
  }

  if (objectResult) {
    return {
      usageData: usageDataFormatted,
      usageUnit: usageUnit,
      limitData: limitDataFormatted,
      limitUnit: limitUnit,
      percent: calPercent(byteToGibiByte(usageData), limitData),
    };
  }

  // Format the output
  return `${usageDataFormatted} ${usageUnit} / ${limitDataFormatted} ${limitUnit}`;
};

const calPercent = (use, limit) => {
  if (use && limit) {
    // Simplified validation and calculation
    use = parseFloat(use);
    limit = parseFloat(limit);

    if (isNaN(use) || isNaN(limit) || limit === 0) return 0;

    const percent = (use / limit) * 100;
    return percent > 100
      ? 100
      : percent <= 9
      ? roundNumber(percent, 1)
      : Math.round(percent);
  }
  return 0;
};

const getUsageStyle = (currentUsage, total, isRde = false) => {
  if (!currentUsage || !total) {
    return {};
  }
  const width = dynamicWidth(currentUsage, total) + "%";
  const background = isRde ? "#87888C" : dynamicBackGround(currentUsage, total);
  return {
    width: width,
    background: background,
  };
};

const dynamicWidth = (currentUsage, total) => {
  if (total > 0) {
    const percent = currentUsage / total;

    return (percent <= 1 ? percent : 1) * 100;
  }
  return 0;
};

const dynamicBackGround = (usage, limit) => {
  const usagePercentage = (usage / limit) * 100;
  // Example: Change background color based on usage percentage
  let backgroundColor = "#2EB85C"; // Default background
  if (usagePercentage > 80) {
    backgroundColor = "#E55353";
  } else if (usagePercentage > 60) {
    backgroundColor = "#F9B115";
  }
  return backgroundColor;
};

const confirmDelete = (title, message, confirmAction) => {
  CommonUIControl.confirm({
    title: title,
    message: message,
    onConfirm: async () => {
      await confirmAction();
    },
  });
};

const truncatedText = (text, size = 25) => {
  const displayName = text;
  if (displayName.length > size) {
    return displayName.substring(0, size) + "...";
  }
  return displayName;
};

const showDate = (date, format = "YYYY/MM/DD HH:mm:ss") => {
  if (date) {
    return moment(date).format(format);
  }
  return "";
};

const minutesToReadable = (minutes) => {
  if (minutes <= 0) {
    return "N/A";
  }

  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  const mins = minutes % 60;

  const daysStr = days > 0 ? `${days}d ` : "";
  const hoursStr = hours > 0 ? `${hours}h ` : "";
  const minsStr = mins > 0 ? `${mins}m` : "";

  return `${daysStr}${hoursStr}${minsStr}`.trim();
};

const thousandsFormat = (num) => {
  if (typeof num !== "number") return num;
  // For numbers less than 1000, return them as-is
  if (num < 1000) {
    return num.toString();
  }

  // Divide by 1000
  const divided = num / 1000;
  // Multiply by 10 and floor to get the first decimal digit
  const floored = Math.floor(divided * 10);

  // If the first decimal digit is 0, just return the integer part with "K"
  if (floored % 10 === 0) {
    return `${Math.floor(divided)}K`;
  } else {
    return `${Math.floor(divided)}.${floored % 10}K`;
  }
};
